$(document).on("click", "#add_title_link", function(e) {
  e.preventDefault()
  $("#add_title_link").before('<input class="form-control" type="text" value name="upload[titles][]">')
})
